(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useCallback, useMemo } from "react";
import qs from "qs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";

const parseQueryString = string => qs.parse(string, {
  ignoreQueryPrefix: true,
  decoder: str => {
    try {
      const decodedString = decodeURIComponent(str);
      return decodedString;
    } catch (e) {
      return str;
    }
  }
});

const useQueryParams = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useMemo(() => parseQueryString(location.search), [location.search]);
  const setQueryParams = useCallback(newParams => {
    // Async issue, need recalculate query params.
    const prevParams = parseQueryString(location.search);
    const nextPrams = { ...prevParams,
      ...newParams
    };
    navigate({
      search: qs.stringify(nextPrams, {
        addQueryPrefix: true
      }),
      replace: true
    }, {
      state: {
        action: "REPLACE"
      }
    }); // if (process.env.NODE_ENV !== "production") {
    //   // eslint-disable-next-line
    //   console.groupCollapsed("UPDATE URL QUERY PARAMS");
    //   // eslint-disable-next-line
    //   console.info("Prev Params: ", prevParams);
    //   // eslint-disable-next-line
    //   console.info("Next Params: ", nextPrams);
    //   // eslint-disable-next-line
    //   console.groupEnd();
    // }
  }, [navigate, location]);
  return [params, setQueryParams];
};

__signature__(useQueryParams, "useLocation{location}\nuseNavigate{navigate}\nuseMemo{params}\nuseCallback{setQueryParams}", () => [useLocation, useNavigate]);

const _default = useQueryParams;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(parseQueryString, "parseQueryString", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/hooks/useQueryParams.js");
  reactHotLoader.register(useQueryParams, "useQueryParams", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/hooks/useQueryParams.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/hooks/useQueryParams.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();